export default "__VITE_ASSET__BGt4JhWL__"